import api from './api.config'

export default new class {
  async propagateAssocsUpdate () {
    await api.axios.put('/groups/assocs/propagateassocsupdate')
  }
}()
